<template>
  <header :class="['header',menuFixedStatus?'menu-fixed':'', 'panel', _isMobile() ? 'mobile' : '']">
    <div class="logo-bar">
      <a-row type="flex" justify="space-between" class="menu-up">
        <a-col :xs="24" :sm="24" :md="sigleLine?4:12" :lg="sigleLine?4:12" :xl="sigleLine?4:12">
          <div class="logo">
            <img :src="logo ? logo : '/img/logo.png'" alt=""/>
          </div>
        </a-col>
        <!-- 头像 -->
        <a-col v-if="!sigleLine" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="login-btn-wrap">
            <a-avatar v-if="$store.state.user.info" @click="toCenter" icon="user" :src="avatarUrl" />
            <span v-if="$store.state.user.info">
              <span @click="toCenter">{{ $store.state.user.info.realname }}</span>
              <a-divider type="vertical" />
              <span @click="handleLogout">退出</span>
            </span>
            <span v-else>
              <span @click="toLogin">登录</span>
              <a-divider v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2'" type="vertical" />
              <span v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2'" @click="toRegister">注册</span>
            </span>
          </div>
        </a-col>
        <!-- 菜单区域 -->
        <a-col :xs="24" :sm="24" :md="sigleLine?16:24" :lg="sigleLine?16:24" :xl="sigleLine?16:24">
          <div
            :class="['menu-bar', showMenu ? 'show' : 'hide']"
            @mouseleave="leave"
            @mouseover="over"
          >
          <t-menu class="menu" mode="horizontal" :menu="menus"></t-menu>
          </div>
        </a-col>
        <!-- 头像 单行-->
        <a-col v-if="sigleLine" :xs="12" :sm="12" :md="4" :lg="4" :xl="4">
          <div class="login-btn-wrap">
            <a-avatar v-if="$store.state.user.info" @click="toCenter" icon="user" :src="avatarUrl" />
            <span v-if="$store.state.user.info">
              <span @click="toCenter">{{ $store.state.user.info.realname }}</span>
              <a-divider type="vertical" />
              <span @click="handleLogout">退出</span>
            </span>
            <span v-else>
              <span @click="toLogin">登录</span>
              <a-divider v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2'" type="vertical" />
              <span v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2'" @click="toRegister">注册</span>
            </span>
          </div>
        </a-col>
        <!-- 非移动端头像 -->
        <!-- <a-col v-if="!_isMobile()" :xs="12" :sm="12" :md="12" :lg="4" :xl="4">
          <div class="login-btn-wrap">
            <a-avatar v-if="$store.state.user.info" @click="toCenter" icon="user" :src="avatarUrl" />
            <span v-if="$store.state.user.info">
              <span @click="toCenter">{{ $store.state.user.info.realname }}</span>
              <a-divider type="vertical" />
              <span @click="handleLogout">退出</span>
            </span>
            <span v-else>
              <span @click="toLogin">登录</span>
              <a-divider type="vertical" />
              <span @click="toRegister">注册</span>
            </span>
          </div>
        </a-col> -->
      </a-row>
    </div>
    <div class="float-menu">
      <div class="float-button" @click="scrollToTop" style="margin-bottom: 12px;">
        <i class="iconfont" style="font-size: 40px;padding-bottom: 10px;">&#xe6ab;</i>
        <div>回到顶部</div>
      </div>
      <div class="float-button" @click="AIChatStatus=true">
        <i class="iconfont" style="font-size: 28px;padding-bottom: 10px;">&#xe60a;</i>
        <div>AI助手</div>
      </div>
    </div>
    <AIChat v-if="AIChatStatus" @closeFn="AIChatStatus=false" />
  </header>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN,SYSTEM_INFO } from "@/store/mutation-types";
import { mapActions } from "vuex";
import { mixinDevice } from "@/utils/mixin.js";
import TMenu from "@/components/menu"
import { jumpMixins } from "@/utils/jumpMixins"
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'
import AIChat from '@/components/tools/AIChat.vue';

export default {
  name: "Header",
  mixins: [mixinDevice, jumpMixins],
  props: {
    //自动隐藏
    autoHide: {
      type: Boolean,
      default: false,
    },
    //是否浮动
    menuFixed:{
      type: Boolean,
      default: true
    },
    //单行显示
    sigleLine:{
      type: Boolean,
      default: true
    },
  },
  components: {
    TMenu,
    AIChat
  },
  data() {
    return {
      AIChatStatus: false,
      showLogin: false,
      showRegister: false,
      showMenu: true,
      logo: "",
      token: "",
      menus: [],
      tenantInfo: {},
      menuFixedStatus: false
    };
  },
  created() {
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.tenantInfo = this.$store.getters.tenantInfo
    let systemInfo = Vue.ls.get(SYSTEM_INFO)
    this.logo = systemInfo&&systemInfo.schoolLogo ? systemInfo.schoolLogo : this.tenantInfo.logo2
    this.menus = this.$store.getters.menuList
  },
  computed:{
    avatarUrl(){
      if(this.$store.state.user.avatar){
        return this.$store.state.user.avatar
      }else if(this.$store.state.user.info && this.$store.state.user.info.avatar){
        return this.$store.state.user.info.avatar
      }else{
        return "/img/avatar.png"
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    onSearch(v) {
      console.log(v);
    },
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    handleScroll(){
      if(this.menuFixed){
        let scrollTop = document.documentElement.scrollTop
        if (scrollTop >= 75) {
          this.menuFixedStatus = true
        } else {
          this.menuFixedStatus = false
        }
      }
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      });
    },
    toCenter() {
        if(this.$store.state.user.info.userIdentity == 2){
            this.$router.push("/teacher")
        }else{
            this.$router.push("/user")
        }
    },
  },
};
</script>
<style lang="less" scoped>
@import '~@assets/iconfont.css';
.hide {
  height: 50px;
  background-color: transparent !important;
  transition: all 0.1s ease;
}

.logo-bar {
  z-index: 99;
  // background: #24A6E9;
  // border-bottom: 1px solid #f5f7fa;
  .menu-up {
    max-width: 1200px;
    margin: auto;
    padding: 10px 0;
    // height: 80px;
    .logo {
      margin-top: 5px;
      margin-right: 10px;
      img {
        display: inline-block;
        height: 50px;
      }
      h2 {
        display: inline;
        font-style: italic;
        font-size: 20px;
        color: #ffffff;
        line-height: 30px;
        text-shadow: #b3b0b0ab 5px 3px 5px;
      }
    }
    .login-btn-wrap {
      cursor: pointer;
      text-align: right;
      margin-top: 20px;
      // margin-right: 50px;
      /deep/.ant-input{
        background-color: transparent;
        color: white;
      }
      /deep/.ant-input-suffix{
        i{
          color: rgba(255, 255, 255, 0.82);
        }
      }
      .ant-avatar {
        margin-right: 5px;
      }
      span {
        color: #fff;
      }
      .help {
        color: gray;
      }
    }
  }
}
.menu-fixed{
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 99;
    background: radial-gradient(ellipse at top left, #4e91ecab 10%, #8992ffab 67%);
}
.menu-bar {
  width: 100%;
  z-index: 999;
  .menu {
    background: transparent;
    max-width: 1200px;
    margin: auto;
    /deep/.ant-menu-item,/deep/.ant-menu-submenu{
      margin: 0 8px;
      border-radius: 11px;
      border: 1px solid #fff;
      line-height: 30px;
      
    }
    /deep/.ant-menu-item:hover,/deep/.ant-menu-submenu:hover{
      border-radius: 11px;
      background: rgba(255,255,255,.2);
      color: #fff;
    }
    /deep/.ant-menu-overflowed-submenu{
      margin: unset;
      border: unset;
    }
    .ant-menu-submenu,
    /deep/.ant-menu-item > a, /deep/.ant-menu-submenu-title > a {
      font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
      font-weight: 600;
      font-size: 16px;
      color: white;
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 15px;
      border-bottom: none !important;
    }
  }
  .ant-menu-horizontal {
    border-bottom:none;
  }
}

.mobile {
  .logo {
    margin-top: 5px;
    margin-left: 15px;
  }
  .login-btn-wrap {
    margin-right: 20px !important;
  }
  .ant-menu-item {
    padding: 0 8px;
  }
  .ant-menu-item > a {
    font-size: 12px !important;
  }
  .menu {
    padding: 0px 15px;
    /deep/.ant-menu-item,/deep/.ant-menu-submenu{
      margin: 0;
    }
  }
}
</style>